import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { GhlEventsTable } from "@/components/crm/ghl/GhlTables";

const STATUSES = ["recibido", "procesando", "procesado", "ignorado", "error", "fallido"];
const CHANNELS = ["WhatsApp", "Instagram", "Facebook", "Correo", "SMS", "Web chat", "Teléfono", "Otros"];

const Filter = ({ value, onChange, options, all, testid }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="h-9 w-44 rounded-xl bg-white" data-testid={testid}><SelectValue /></SelectTrigger>
    <SelectContent>
      <SelectItem value="all">{all}</SelectItem>
      {options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const GhlEventsPanel = ({ reloadKey }) => {
  const [status, setStatus] = useState("all");
  const [channel, setChannel] = useState("all");
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const params = { ...(status !== "all" && { status }), ...(channel !== "all" && { channel }) };
    api.get("/admin/integrations/ghl/events", { params }).then((r) => setEvents(r.data));
  }, [status, channel, reloadKey]);

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center gap-3">
        <Filter value={status} onChange={setStatus} options={STATUSES} all="Todos los estados" testid="ghl-events-filter-status" />
        <Filter value={channel} onChange={setChannel} options={CHANNELS} all="Todos los canales" testid="ghl-events-filter-channel" />
        <span className="text-sm text-slate-500" data-testid="ghl-events-count">{events.length} eventos</span>
      </div>
      <GhlEventsTable events={events} />
    </div>
  );
};
